'use strict';
import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { NavigationConfigService } from '@ispm/dashboard/navigation/services/navigationConfig.service';
import { UserService } from '@ispm/user/services/user.service';
import {ChannelTypes, DashboardService} from '../../../../../worklist/services/dashboard.service';
import { take } from 'rxjs/operators';
import {Router} from "@angular/router";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'gen-add-test',
  templateUrl: './add-test.component.html',
  styleUrls: ['./add-test.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AddTestComponent implements OnInit {
  @Input() oldStyle: boolean;
  @Input() newTestConfig: any;
  @Output() closePanel: EventEmitter<boolean> = new EventEmitter();
  @Output() popupTestCreation: EventEmitter<{testConfig: any, patientId?: string}> = new EventEmitter();
  private params: { patientId: string, mrn: string, EMRIntegration?: string } = {
    patientId: '',
    mrn: null,
  };

  constructor(private routerManagerService: RouterManagerService,
              private route: Router,
              private _navigationConfig: NavigationConfigService,
              private _dashboardService: DashboardService,
              private userService: UserService) { }

  ngOnInit() {
    if (this.routerManagerService.parameters.patientId) {
      this.params.patientId = this.routerManagerService.parameters.patientId;
      if (this.params.patientId) {
        //Loading patient details to the cache for patient details panel usage, patient search panel and more
        this.userService.getPatient(this.params.patientId, true, true).pipe(take(1)).subscribe();
      }
    }
    if (this.routerManagerService.parameters.mrn) {
      this.params.mrn = this.routerManagerService.parameters.mrn;
    }

    if (this.routerManagerService.queryParameters?.EMRIntegration) {
      this.params.EMRIntegration = this.routerManagerService.queryParameters.EMRIntegration;
    }
  }

  addTest() {
    // This part handles cases in which no test config is available - this can happen when no worklist template was loaded,
    // like in the case that user search for a patient via Search Patient panel and then clicked on New Test.
    this._navigationConfig.getCurrentApplication().take(1).subscribe(appConfig => {
      if (appConfig && appConfig.searchPatientNewButtonConfig){
        this.closePanel.emit(true);
        let currentTestConfig: any;
        //searchPatientNewButtonConfig is an array which enables to config different add button configurations
        //to different tab of the same application- for example Lung Screening and Lung Incidental.
        //In case it is an array with only one element, the config will be applied to all tabs.
        if (Array.isArray(appConfig.searchPatientNewButtonConfig)){
          if (appConfig.searchPatientNewButtonConfig.length === 1){
            currentTestConfig = appConfig.searchPatientNewButtonConfig[0];
          }
          else if (appConfig.searchPatientNewButtonConfig.length > 1){
            this._navigationConfig.getNavigationConfig().pipe(take(1)).subscribe( data => {
              const currentTabKey = data['currentAppSelectedTab'];
              for (const newButtonConfig of appConfig.searchPatientNewButtonConfig){
                if (newButtonConfig.subApplicationKey === currentTabKey){
                  currentTestConfig = newButtonConfig;
                  break;
                }
              }
            });
          }
        }
        if (!currentTestConfig){
          console.error('currentAppSelectedTab->addTest: an array of searchPatientNewButtonConfig is missing');
          return;
        }
        this.popupTestCreation.emit({testConfig: currentTestConfig, patientId: this.params.patientId});
      }
      else if (this.newTestConfig) { // If searchPatientNewButtonConfig doe not exist in app configuration, opening the general test creation component (as was before harmonization)
        this._dashboardService.runConfiguration(this.newTestConfig);
      } else {
        // In this case there is no appConfiguration will fetch newTestConfig from worklistTemplate
        if (this._dashboardService.newTestConfig) {
          this._dashboardService.runConfiguration(this._dashboardService.newTestConfig, this._dashboardService.dashboardConfig, undefined, ChannelTypes.AllItemsChannel);
        } else {
          this.route.navigate([`Pathologist/order`], {queryParams: this.params});
        }
      }
    })
  }
}
